/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/exhaustive-deps */
import { useForm, useWatch } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
  DatePicker,
  FormLabel,
  Checkbox,
} from "@repo/ui";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";
import FormSelect from "ui/select";
import { FormDropdown } from "ui/combo-box";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import {
  IMS_TYPE,
  INCIDENT_CATEGORIES,
  INCIDENT_TYPES,
  TOGGLE,
} from "../constants";
import {
  useLookupCustomers,
  useLookupGetEmployeeDetail,
  useLookupGetEmployees,
  useLookupGetRegion,
} from "services/lookups";
import { useEffect, useRef, useState } from "react";
import {
  useCreateIncidentTicket,
  useDeleteIncidentAttachment,
  useGetIncidentDetails,
  useGetIncidentTicketDetails,
  useSaveIncidentTicket,
  useSubmitIncidentTicket,
} from "services/tickets";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { Trash, Upload } from "lucide-react";
import { useGetImageURL } from "services/common";
import moment from "moment";
import { useUser } from "hooks/use-user";
import { TicketCreateHeader } from "components/tickets/ticket-create-header";
import { getLocalISODateString } from "utils/date-utils";
import { PDFExport } from "@progress/kendo-react-pdf";
import Logo from "../../../assets/images/logo.png";
const emptyTicket = {
  openedBy: "",
  openedFor: "",
  reportedBy: "",
  IMSType: "Standard",
  reportedByTGID: "",
  incidentCategory: "",
  reportedByContactNumber: "",
  typeOfIncident: "",
  isCivilDefenseInvolved: "No",
  isPoliceInvolved: "No",
  isMunicipalityInvolved: "No",
  isAmbulanceInvolved: "No",
  isDocInformed: "No",
  isPoliceAssistanceRequested: "No",
  isAmbulanceAssistanceRequested: "No",
  isReportedToCrisisMgmt: "No",
  reportToCrisesManagement: "No",
  newsMediaCoverage: "",
  businessImpact: "",
  incidentDateTime: new Date(),
  noOfInjuries: 0,
  noOfFatalities: 0,
  isTransguardPeople: "No",
  isContractorPeople: "No",
  isThirdPartyPeople: "No",
  peopleOnDuty: "No",
  staffInvolvedName: "",
  region: "",
  staffInvolvedTGID: "",
  location: "",
  staffInvolvedContactNumber: "",
  staffInvolvedDepartment: "",
  staffInvolvedDesignation: "",
  staffInvolvedNationality: "",
  staffInvolvedDetails: {},
  attachments: [],
  remarks: "",
};

const booleanFields = [
  "isCivilDefenseInvolved",
  "isPoliceInvolved",
  "isMunicipalityInvolved",
  "isAmbulanceInvolved",
  "isDocInformed",
  "isPoliceAssistanceRequested",
  "isAmbulanceAssistanceRequested",
  "isReportedToCrisisMgmt",
  "reportToCrisesManagement",
  "isTransguardPeople",
  "isContractorPeople",
  "isThirdPartyPeople",
  "peopleOnDuty",
];
export default function CreateAccidentIncidentReportingStandard() {
  const [imagePreview, setImagePreview] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [ticketDetails, setTicketDetails] = useState({});
  const [base64Image, setBase64Image] = useState("");
  const pdfExportComponent = useRef(null);
  const params = useParams();
  const navigate = useNavigate();
  const user = useUser();
  const isCCASupervisor = user.Roles.includes("CC Supervisor");

  const form = useForm({
    defaultValues: { ...emptyTicket, internal: true },
  });

  const generalProps = {
    errors: form.formState.errors,
    control: form.control,
    hideIcons: true,
  };

  const formValues = useWatch({ control: generalProps.control });
  const verificationRules = {
    reportedBy: { required: "Please Enter Value" },
    reportedByEmail: { required: "Please Enter Value" },
    priority: { required: "Please Enter Value" },
    staffInvolvedRegion: { required: "Please Enter Value" },
    companyName: { required: "Please Enter Value" },
    remarks: { required: "Please Enter Value" },
    incidentDateTime: { required: "Please Enter Value" },
    category: { required: "Please Enter Value" },
    subCategory: { required: "Please Enter Value" },
    location: { required: "Please Enter Value" },
  };
  const { mutate: getCustomersList, data: customersListRes } =
    useLookupCustomers();
  const {
    mutate: getEmployees,
    data: employeesListRes,
    isPending: gettingEmployeesList,
  } = useLookupGetEmployees();
  const {
    mutateAsync: getEmployeeDetails,

    isPending: gettingEmployeeDetail,
  } = useLookupGetEmployeeDetail();
  const {
    mutate: getRegion,
    data: regionsListRes,
    isPending: gettingRegionsList,
  } = useLookupGetRegion();
  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
  } = useCreateIncidentTicket();
  const {
    mutate: saveTicket,
    data: saveTicketRes,
    isPending: savingTicket,
  } = useSaveIncidentTicket();
  const {
    mutate: submitTicket,
    data: submitTicketRes,
    isPending: submittingTicket,
  } = useSubmitIncidentTicket();
  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicket,
    reset: restTicketDetails,
  } = useGetIncidentTicketDetails();
  const {
    mutate: getIncidentDetails,
    data: incidentDetailsRes,
    isPending: gettingIncidentDetails,
    reset: restIncidentDetails,
  } = useGetIncidentDetails();
  const {
    mutate: deleteAttachment,
    data: deleteAttachmentRes,
    reset: resetDeleteAttachment,
  } = useDeleteIncidentAttachment();

  const { mutateAsync: getImageURL } = useGetImageURL();

  const reportedForValue = form.watch("openedFor");
  const internal = form.watch("internal");

  useEffect(() => {
    if (reportedForValue) {
      form.setValue("staffInvolvedName", reportedForValue);
    }

    onStaffInvolvedChange(reportedForValue);
  }, [reportedForValue]);

  useEffect(() => {
    getEmployees();
    getCustomersList();
    getRegion("UAE");

    const convertToBase64 = async (imgUrl) => {
      const response = await fetch(imgUrl);
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    };

    convertToBase64(Logo).then(setBase64Image);

    if (params.ticketId) {
      getTicket(params.ticketId);
    }
  }, []);
  useEffect(() => {
    if (createTicketRes || saveTicketRes || submitTicketRes) {
      navigate(PATHS.allServiceAndNonServiceCalls);
    }
    if (ticketDetailsRes) {
      const details = ticketDetailsRes?.data[0];
      getIncidentDetails(details.requestId);

      restTicketDetails();
    }
    if (incidentDetailsRes) {
      const details = incidentDetailsRes.data;
      const incidentDateTime = details.incidentDateTime
        ? new Date(moment(details.incidentDateTime, "DD-MMM-YYYY hh:mm A"))
        : new Date();
      booleanFields.forEach((elm) => {
        details[elm] = details[elm] ? "Yes" : "No";
      });
      const getImages = async () => {
        return Promise.all(
          details.uploadedFiles.map(async (file) => ({
            ...file,
            filePath: await getImageURL(file.filePath),
          }))
        );
      };

      (async () => {
        const images = await getImages();
        setUploadedImages(images);
      })();
      // const staffInvolved = details.staffInvolved?.[0] || {};
      const staffSource =
        details.staffInvolved && Object.keys(details.staffInvolved).length > 0
          ? details.staffInvolved
          : details.openedFor || {};
      const _ticketDetails = {
        ...details,
        IMSType: details.activityType?.split(" ").pop() || "Standard",

        reportedBy: details.reportedBy?.employeeId
          ? details.reportedBy?.employeeId
          : details.reportedBy?.name || "",
        reportedByTGID: details.reportedBy?.tgId || "",
        reportedByContactNo: details.reportedBy?.contactNumber || "",
        reportedByDetails: details.reportedBy
          ? {
              ...details.reportedBy,
              employeeName: details.reportedBy.name,
              id: details.reportedBy.employeeId,
              region: details.reportedBy.region,
              tgId: details.reportedBy.tgId,
              contactNumber: details.reportedBy.contactNumber,
              department: details.reportedBy.department,
              businessUnit: details.reportedBy.businessUnit,
              designation: details.reportedBy.designation,
              nationality: details.reportedBy.nationality,
              email: details.reportedBy.email,
            }
          : {},

        openedFor: details.openedFor?.employeeId || "",
        openedForDetails: details.openedFor
          ? {
              ...details.openedFor,
              employeeName: details.openedFor.name,
              id: details.openedFor.employeeId,
              region: details.openedFor.region,
              tgId: details.openedFor.tgId,
              contactNumber: details.openedFor.contactNumber,
              department: details.openedFor.department,
              businessUnit: details.openedFor.businessUnit,
              designation: details.openedFor.designation,
              nationality: details.openedFor.nationality,
              email: details.openedFor.email,
            }
          : {},

        staffInvolvedTGID: staffSource.tgId || "",
        staffInvolvedName: staffSource.name || "",
        staffInvolvedContactNumber: staffSource.contactNumber || "",
        staffInvolvedDesignation: staffSource.designation || "",
        staffInvolvedDepartment: staffSource.department || "",
        staffInvolvedNationality: staffSource.nationality || "",
        staffInvolvedRegion: staffSource.region || details.openedFor?.region,
        incidentDateTime,
        attachments: [],
      };

      form.reset({ ..._ticketDetails });
      setTicketDetails({ ..._ticketDetails });
      restIncidentDetails();
    }
    if (deleteAttachmentRes) {
      getTicket(params.ticketId);
      resetDeleteAttachment();
    }
  }, [
    createTicketRes,
    saveTicketRes,
    submitTicketRes,
    ticketDetailsRes,
    incidentDetailsRes,
    deleteAttachmentRes,
  ]);

  const createPayload = () => {
    const data = form.getValues();
    const customer = customersListRes?.data.find(
      (elm) => elm.name === "Transguard Group (TG)"
    );

    const safeEmployee = (details) => ({
      employeeId: details?.id || "null",
      name: details?.employeeName || details?.name || "",
      region: details.staffInvolvedRegion,
      tgId: details?.tgId || "",
      contactNumber: details?.contactNumber || "",
      department: details?.department || "",
      businessUnit: details?.businessUnit || "",
      designation: details?.designation || "",
      nationality: details?.nationality || "",
      email: details?.email || "",
    });

    const payload = {
      activityType: `Incident - ${data.IMSType}`,
      category: data.category,
      subCategory: data.subCategory,
      customerId: customer?.customerId || "",
      assignmentGroup: "IMS Group",
      creationChannel: "Web",
      priority: data.IMSType === "Emergency" ? 1 : 3,

      reportedBy: data.internal
        ? safeEmployee(data.reportedByDetails)
        : {
            employeeId: null,
            name: data.reportedBy || "",
            tgId: "",
            contactNumber: data.reportedByContactNo || "",
            region: "",
            department: "",
            businessUnit: "",
            designation: "",
            nationality: "",
            email: "",
          },
      openedFor: {
        employeeId: data.openedForDetails?.id || "null",
        name:
          data.openedForDetails?.employeeName ||
          data.openedForDetails?.name ||
          "",
        region: data.staffInvolvedRegion || "",
        tgId: data.openedForDetails?.tgId || "",
        contactNumber: data.openedForDetails?.contactNumber || "",
        department: data.openedForDetails?.department || "",
        businessUnit: data.openedForDetails?.businessUnit || "",
        designation: data.openedForDetails?.designation || "",
        nationality: data.openedForDetails?.nationality || "",
        email: data.openedForDetails?.email || "",
      },

      isCivilDefenseInvolved: data.isCivilDefenseInvolved === "Yes",
      isPoliceInvolved: data.isPoliceInvolved === "Yes",
      isMunicipalityInvolved: data.isMunicipalityInvolved === "Yes",
      isAmbulanceInvolved: data.isAmbulanceInvolved === "Yes",
      isDocInformed: data.isDocInformed === "Yes",
      isPoliceAssistanceRequested: data.isPoliceAssistanceRequested === "Yes",
      isAmbulanceAssistanceRequested:
        data.isAmbulanceAssistanceRequested === "Yes",
      isReportedToCrisisMgmt: data.isReportedToCrisisMgmt === "Yes",
      newsMediaCoverage: data.newsMediaCoverage,
      businessImpact: data.businessImpact,
      incidentDateTime: getLocalISODateString(data.incidentDateTime),
      noOfInjuries: Number(data.noOfInjuries),
      noOfFatalities: Number(data.noOfFatalities),

      isTransguardPeople: data.isTransguardPeople === "Yes",
      isContractorPeople: data.isContractorPeople === "Yes",
      isThirdPartyPeople: data.isThirdPartyPeople === "Yes",
      peopleOnDuty: data.peopleOnDuty === "Yes",

      location: data.location,
      remarks: data.remarks,
      incidentReportHtmlContent: exportDivAsHTML(),
      attachments: data?.attachments || [],
    };
    return payload;
  };

  const handleInternalChange = (checked) => {
    const value = Boolean(checked);
    form.setValue("internal", value);

    form.setValue("reportedBy", "");
    form.setValue("reportedByTGID", "");
    form.setValue("reportedByContactNo", "");
    form.setValue("reportedByDetails", {});
  };

  const onSave = () => {
    createTicket(createPayload());
  };
  const onSaveAsDraft = () => {
    saveTicket(createPayload());
  };
  const onRequestorChange = async (data) => {
    try {
      const requestorDetailsRes = await getEmployeeDetails(data);
      if (requestorDetailsRes?.data) {
        const requestorDetails = requestorDetailsRes.data;
        form.setValue("reportedByTGID", requestorDetails.tgId);
        form.setValue("reportedByContactNo", requestorDetails.contactNumber);
        form.setValue("reportedByDetails", requestorDetails);
      }
    } catch (e) {}
  };

  const onOpenedForChange = async (data) => {
    try {
      const requestorDetailsRes = await getEmployeeDetails(data);
      if (requestorDetailsRes?.data) {
        const requestorDetails = requestorDetailsRes.data;
        form.setValue("openedForDetails", requestorDetails);
        // form.setValue("staffInvolvedRegion", "");
      }
    } catch (e) {}
  };
  const onStaffInvolvedChange = async (data) => {
    try {
      const requestorDetailsRes = await getEmployeeDetails(data);
      if (requestorDetailsRes?.data) {
        const requestorDetails = requestorDetailsRes.data;
        form.setValue("staffInvolvedTGID", requestorDetails.tgId);
        form.setValue(
          "staffInvolvedContactNumber",
          requestorDetails.contactNumber
        );
        form.setValue("staffInvolvedDepartment", requestorDetails.department);
        form.setValue("staffInvolvedDesignation", requestorDetails.designation);
        form.setValue("staffInvolvedNationality", requestorDetails.nationality);
        // form.setValue("staffInvolvedRegion", requestorDetails.region);
        form.setValue("staffInvolvedDetails", requestorDetails);
      }
    } catch (e) {}
  };
  const onSubmit = () => {
    const _data = form.getValues();
    const payload = {
      ticketId: _data.ticketId,
      ...createPayload(),
    };
    submitTicket({ ...payload });
  };

  const onReset = () => {
    form.reset({ ...ticketDetails });
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      const attachments = form.getValues("attachments");
      reader.onload = (e) => {
        const base64DataUrl = e.target.result;
        const base64String = base64DataUrl.split(",")[1]; // remove data:image/...;base64,

        const fileObject = {
          fileName: file.name,
          contentType: file.type,
          contents: base64String,
        };

        setImagePreview([...imagePreview, base64DataUrl]);

        form.setValue("attachments", [...attachments, fileObject]);
        // For JSON
      };

      reader.readAsDataURL(file); // read file as base64
    }
  };
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(",")[1]); // remove "data:application/pdf;base64,"
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const handleGenerate = async () => {
    // 👇 Generate PDF in memory (not downloaded)
    const blob = await pdfExportComponent.current.exportPDF();

    // Convert to base64
    const base64 = await blobToBase64(blob);

    // Build your object
    const pdfFile = {
      fileName: "report.pdf",
      contentType: "application/pdf",
      content: base64,
    };

    console.log("PDF Object:", pdfFile);
    // 👇 You can now use this object anywhere in your code
    // e.g. send to API, store locally, etc.
  };
  const exportDivAsHTML = () => {
    if (!pdfExportComponent.current) return;

    // Get the div's inner HTML
    const divContent = pdfExportComponent.current.innerHTML;

    // Create full HTML document
    const htmlDocument = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Incident Report</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 0; padding: 0; }
        </style>
      </head>
      <body>
        ${divContent}
      </body>
      </html>
    `;
    return htmlDocument;
    // Create a Blob and download as .html file
  };

  return (
    <>
      {savingTicket ||
      creatingTicket ||
      gettingEmployeesList ||
      gettingEmployeeDetail ||
      submittingTicket ||
      gettingRegionsList ||
      gettingTicket ||
      gettingIncidentDetails ? (
        <Loader />
      ) : null}

      <div className="form-container">
        <TicketCreateHeader
          canUpload
          isDraft={form.watch("status") === "Draft"}
          onSaveAsDraft={form.handleSubmit(onSaveAsDraft)}
          onSubmit={form.handleSubmit(onSubmit)}
          onSave={form.handleSubmit(onSave)}
          handleFileChange={handleFileChange}
          onReset={onReset}
          onCancel={oncancel}
        />

        <Card className="form-card shadow-lg mx-0">
          <CardHeader>
            <CardTitle>Incident Reporting</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form
              // onSubmit={form.handleSubmit(onSubmit)}
              className="space-y-8 custom-form-v2"
            >
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                <div className="form-row-d-50">
                  <FormField
                    control={form.control}
                    name="internal"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Reported By Employee</FormLabel>
                        <div>
                          <FormControl>
                            <Checkbox
                              id="internal"
                              checked={field.value}
                              onCheckedChange={handleInternalChange}
                            />
                          </FormControl>
                        </div>
                      </FormItem>
                    )}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Reported For"
                    name="openedFor"
                    isRequired
                    data={
                      employeesListRes?.data.map((elm) => ({
                        ...elm,
                        name: `${elm.tgId}-${elm.employeeName}`,
                      })) || []
                    }
                    text="name"
                    id="id"
                    placeholder="Select Employee"
                    rules={verificationRules.openedFor}
                    onChange={onOpenedForChange}
                  />
                  {internal ? (
                    <FormDropdown
                      {...generalProps}
                      label="Reported By"
                      name="reportedBy"
                      isRequired
                      data={
                        employeesListRes?.data.map((elm) => ({
                          ...elm,
                          name: `${elm.tgId}-${elm.employeeName}`,
                        })) || []
                      }
                      text="name"
                      id="id"
                      placeholder="Select Employee"
                      rules={verificationRules.reportedBy}
                      onChange={onRequestorChange}
                    />
                  ) : (
                    <FormInput
                      {...generalProps}
                      label="Reported By"
                      name="reportedBy"
                      isRequired
                      placeholder="Enter name manually"
                      rules={verificationRules.openedFor}
                    />
                  )}{" "}
                  <FormSelect
                    {...generalProps}
                    isRequired
                    name="IMSType"
                    label="IMS Type"
                    placeholder="Select Type"
                    data={IMS_TYPE}
                    id="id"
                    text="text"
                    rules={verificationRules.IMSType}
                  />
                  <FormInput
                    {...generalProps}
                    isRequired
                    name="reportedByTGID"
                    label="Requester TGID"
                    inputProps={{ readOnly: true }}
                    rules={verificationRules.reportedByTGID}
                  />{" "}
                  <FormDropdown
                    {...generalProps}
                    isRequired
                    label="Incident Category"
                    name="category"
                    placeholder="Select Category"
                    data={INCIDENT_CATEGORIES}
                    id="id"
                    text="text"
                    rules={verificationRules.category}
                  />
                  <FormInput
                    {...generalProps}
                    isRequired
                    name="reportedByContactNo"
                    label="Requester Contact No"
                    inputProps={{ readOnly: internal }}
                  />
                  <FormDropdown
                    {...generalProps}
                    isRequired
                    name="subCategory"
                    label="Type of Incident"
                    placeholder="Select Type"
                    data={INCIDENT_TYPES}
                    rules={verificationRules.subCategory}
                    id="id"
                    text="text"
                  />
                </div>
                <Accordion
                  type="multiple"
                  defaultValue={[
                    "externalAgencies",
                    "requestedAssistance",
                    "people",
                    "staffInvolved",
                  ]}
                  collapsible
                  className="w-full"
                >
                  <AccordionItem value="externalAgencies" className="w-full">
                    <div>
                      <AccordionTrigger
                        className="bg-transparent"
                        style={{ background: "transparent" }}
                      >
                        External Agencies Involved
                      </AccordionTrigger>
                    </div>

                    <AccordionContent className="w-full">
                      <div className="form-row-d-50">
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isCivilDefenseInvolved"
                          label="Civil Defense"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isPoliceInvolved"
                          label="Police"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isMunicipalityInvolved"
                          label="Muncipality"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        {form.watch("IMSType") === "Emergency" ? (
                          <>
                            <FormSelect
                              {...generalProps}
                              isRequired
                              name="isAmbulanceInvolved"
                              label="Ambulance"
                              placeholder="Select Value"
                              data={TOGGLE}
                              id="id"
                              text="text"
                            />
                            <FormSelect
                              {...generalProps}
                              isRequired
                              name="isDocInformed"
                              label="DOC Informed"
                              placeholder="Select Value"
                              data={TOGGLE}
                              id="id"
                              text="text"
                            />
                          </>
                        ) : null}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                  <AccordionItem value="requestedAssistance" className="w-full">
                    <div>
                      <AccordionTrigger
                        className="bg-transparent"
                        style={{ background: "transparent" }}
                      >
                        What Assistance has been Requested
                      </AccordionTrigger>
                    </div>

                    <AccordionContent className="w-full">
                      <div className="form-row-d-50">
                        <FormSelect
                          {...generalProps}
                          isRequired
                          label="Police"
                          name="isPoliceAssistanceRequested"
                          placeholder="Select Value"
                          data={TOGGLE}
                          text="text"
                          id="id"
                        />
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isAmbulanceAssistanceRequested"
                          label="Ambulance"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormSelect
                          {...generalProps}
                          name="isReportedToCrisisMgmt"
                          label="Report To Crises Management"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormInput
                          {...generalProps}
                          name="newsMediaCoverage"
                          label="News of Media Coverage"
                        />
                        <FormInput
                          {...generalProps}
                          name="businessImpact"
                          label="Business Impact, Damage or Loss"
                        />
                        <FormField
                          control={generalProps.control}
                          name="incidentDateTime"
                          // rules={rules ? { ...rules } : {}}
                          render={({ field }) => (
                            <FormItem>
                              <Label
                                label="Date & Time of Incident"
                                isRequired
                              />
                              <FormControl>
                                <div className="form-date-picker">
                                  <DateTimePicker
                                    variant="secondary"
                                    className="px-3 py-2 border border-secondary rounded-md "
                                    value={field.value}
                                    placeholder="Select Date"
                                    onChange={(e) => {
                                      field.onChange(e.target.value);
                                    }}
                                  />
                                </div>
                              </FormControl>{" "}
                            </FormItem>
                          )}
                        />

                        <FormInput
                          {...generalProps}
                          name="noOfInjuries"
                          label="No. of Injuries"
                          inputProps={{ type: "number" }}
                        />
                        <FormInput
                          {...generalProps}
                          name="noOfFatalities"
                          label="No. of Fatalities"
                          inputProps={{ type: "number" }}
                        />
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                  <AccordionItem value="people" className="w-full">
                    <div>
                      <AccordionTrigger
                        className="bg-transparent"
                        style={{ background: "transparent" }}
                      >
                        People
                      </AccordionTrigger>
                    </div>

                    <AccordionContent className="w-full">
                      <div className="form-row-d-50">
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isTransguardPeople"
                          label="Transguard"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isContractorPeople"
                          label="Contractor"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="isThirdPartyPeople"
                          label="Third Party"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="peopleOnDuty"
                          label="is On Duty"
                          placeholder="Select Value"
                          data={TOGGLE}
                          id="id"
                          text="text"
                        />
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                  <AccordionItem value="staffInvolved" className="w-full">
                    <div>
                      <AccordionTrigger
                        className="bg-transparent"
                        style={{ background: "transparent" }}
                      >
                        Staff Involved Information
                      </AccordionTrigger>
                    </div>

                    <AccordionContent className="w-full">
                      <div className="form-row-d-50">
                        <FormDropdown
                          {...generalProps}
                          label="Staff Involved Name"
                          name="staffInvolvedName"
                          isRequired
                          data={
                            employeesListRes?.data.map((elm) => ({
                              ...elm,
                              name: `${elm.tgId}-${elm.employeeName}`,
                            })) || []
                          }
                          text="name"
                          id="id"
                          placeholder="Select Employee"
                          rules={verificationRules.reportedBy}
                          onChange={onStaffInvolvedChange}
                          disabled
                        />

                        <FormSelect
                          {...generalProps}
                          isRequired
                          name="staffInvolvedRegion"
                          label="Region"
                          placeholder="Select Region"
                          data={regionsListRes?.data || []}
                          id="name"
                          text="name"
                          rules={verificationRules.staffInvolvedRegion}
                        />
                        <FormInput
                          {...generalProps}
                          name="staffInvolvedTGID"
                          label="Staff Involved TGID"
                          disabled
                        />
                        <FormInput
                          {...generalProps}
                          isRequired
                          label="Location"
                          name="location"
                          rules={verificationRules.location}
                        />

                        <FormInput
                          {...generalProps}
                          name="staffInvolvedContactNumber"
                          label="Staff Involved Contact No."
                          disabled
                        />
                        <FormInput
                          {...generalProps}
                          name="staffInvolvedDesignation"
                          label="Staff Involved Designation"
                          disabled
                        />
                        <FormInput
                          {...generalProps}
                          name="staffInvolvedNationality"
                          label="Staff Involved Nationality"
                          disabled
                        />
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                  <AccordionItem value="attachments" className="w-full">
                    <div>
                      <AccordionTrigger
                        className="bg-transparent"
                        style={{ background: "transparent" }}
                      >
                        Attachments
                      </AccordionTrigger>
                    </div>

                    <AccordionContent className="w-full">
                      <div className="form-row-d-50">
                        {uploadedImages?.map((elm, index) => (
                          <div
                            className="border border-solid-secondary relative w-[200px] h-[200px"
                            key={index}
                          >
                            <a
                              href={elm}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                className="] object-contain"
                                src={elm.filePath}
                                alt="preview"
                              />
                            </a>
                          </div>
                        ))}
                        {imagePreview?.map((elm, index) => (
                          <div
                            className="border border-solid-secondary relative w-[200px] h-[200px"
                            key={index}
                          >
                            <Button
                              className="absolute top-1 right-2 z-[1]"
                              variant="secondary"
                              type="button"
                              onClick={() => {
                                const attachments = imagePreview;

                                attachments.splice(index, 1);
                                form.setValue("attachments", attachments, {
                                  shouldDirty: true,
                                });
                                setImagePreview([...attachments]);
                              }}
                            >
                              <Trash />{" "}
                            </Button>{" "}
                            <a
                              href={elm}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                className="] object-contain"
                                src={elm}
                                alt="preview"
                              />
                            </a>
                          </div>
                        ))}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    isRequired
                    rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Purpose of Call"
                            isRequired
                            style={{
                              justifyContent: "flex-start",
                              textAlign: "left",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
              </CardContent>
              <div
                style={{ position: "absolute", left: "-100000000px", top: 0 }}
              >
                <div
                  ref={pdfExportComponent}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <table
                    width="100%"
                    style={{ borderCollapse: "collapse", fontSize: "12px" }}
                  >
                    <thead>
                      <tr>
                        <th width="15%" />
                        <th width="65%" />
                        <th width="20%" />
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        style={{
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        <td style={{ padding: "12px 4px " }}>
                          <img
                            src={base64Image}
                            alt="log"
                            style={{ height: "100px", objectFit: "contain" }}
                          />
                        </td>
                        <td style={{ padding: "12px 4px" }}>
                          <h1
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                          >
                            Transguard Group
                            <br />
                            MAJOR/MINOR INCIDENT ANNOUNCEMENT
                          </h1>
                        </td>
                        <td style={{ padding: "12px 4px" }}>
                          <div>
                            <p style={{ fontSize: "12px", textAlign: "right" }}>
                              Ref:FRM-HSE-074
                              <br /> Ver 1.0 / Date 27 JAN 23
                            </p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="100%"
                    style={{
                      borderCollapse: "collapse",
                      marginTop: "16px",
                      fontSize: "12px",
                    }}
                  >
                    <thead>
                      <tr>
                        <th width="15%" />
                        <th width="5%" />
                        <th width="80%" />
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ padding: "4px" }}>
                          <h1 style={{ fontWeight: "bold", fontSize: "12px" }}>
                            Report Title:
                          </h1>
                        </td>
                        <td style={{ padding: "4px" }} />
                        <td style={{ padding: "4px" }}>Interaction Details</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "4px" }}>
                          <h1 style={{ fontWeight: "bold", fontSize: "12px" }}>
                            Run Date and Time:
                          </h1>
                        </td>
                        <td style={{ padding: "4px" }} />
                        <td style={{ padding: "4px" }}>{`{CreateDateTime}`}</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "4px" }}>
                          <h1 style={{ fontWeight: "bold", fontSize: "12px" }}>
                            Run by:
                          </h1>
                        </td>
                        <td style={{ padding: "4px" }} />
                        <td style={{ padding: "4px" }}>System Administrator</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "4px" }}>
                          <h1 style={{ fontWeight: "bold", fontSize: "12px" }}>
                            Table Name:
                          </h1>
                        </td>
                        <td style={{ padding: "4px" }} />
                        <td style={{ padding: "4px" }}>Interaction</td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="100%"
                    style={{ borderCollapse: "collapse", fontSize: "12px" }}
                  >
                    <thead>
                      <tr>
                        <th width="25%" />
                        <th width="25%" />
                        <th width="25%" />
                        <th width="25%" />
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            backgroundColor: "#659bcf",
                            color: "white",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Interaction
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Reference Number:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {`{TicketNumber}`}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Reported By:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.reportedByDetails?.employeeName ||
                            formValues.reportedBy}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Opened For:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.openedForDetails?.employeeName || "N/A"}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          TGID:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.openedForDetails?.tgId || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Country:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          United Arab Emirates
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Business Unit:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.openedForDetails?.businessUnit || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Contact:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Transguard Group LLC
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Contact Number:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.openedForDetails?.contactNumber || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Created:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {`{CreateDateTime}`}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Reported By Email:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.reportedByDetails?.email || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Incident Location:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.location || "N/A"}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Date/Time of Incident:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.incidentDateTime
                            ? moment(formValues.incidentDateTime).format(
                                "DD-MM-YYYY HH:MM"
                              )
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan="4"
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Incident Description:
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan="4"
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.remarks || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            backgroundColor: "#659bcf",
                            color: "white",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Additional Information
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Business Impact/Damage/Loss:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.businessImpact || "N/A"}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Report To Crises Management Group?
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.isReportedToCrisisMgmt || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          No. of Injuries:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.noOfInjuries || "N/A"}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          No. of Fatalities:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.noOfFatalities || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Incident Category:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.category || "N/A"}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Type of Incident:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.subCategory || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          News Media Coverage:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.newsMediaCoverage || "N/A"}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          On/Off Duty:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.peopleOnDuty === "Yes"
                            ? "On Duty"
                            : "Off Duty"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            backgroundColor: "#659bcf",
                            color: "white",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          People
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Transguard:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.isTransguardPeople}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Third Party:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.isThirdPartyPeople}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Contractor:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.isContractorPeople}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            backgroundColor: "#659bcf",
                            color: "white",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          External Agencies Involved
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Civil Defense:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.isCivilDefenseInvolved}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Dubai Municipality:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.isMunicipalityInvolved}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Police:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.isPoliceInvolved}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Ambulance:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.isAmbulanceInvolved}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        />
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        />
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          DOC Informed (Contact 8001444):
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.isDocInformed}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={4}
                          style={{
                            backgroundColor: "#659bcf",
                            color: "white",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          What Assistance has been Requested
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Police:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.isPoliceAssistanceRequested}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Ambulance:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {formValues.isAmbulanceAssistanceRequested}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Closed:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {`{ClosedDateTime}`}
                        </td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Closed By:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {`{ClosedBy}`}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        ></td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        ></td>
                        <td
                          style={{
                            backgroundColor: "#dfdfdf",
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          Closed By TGID:
                        </td>
                        <td
                          style={{
                            padding: "4px",
                            border: "4px solid white",
                          }}
                        >
                          {`{ClosedByTgId}`}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="100%"
                    style={{
                      width: "100%",
                      marginTop: "150px",
                      borderTop: "1px solid black",
                      borderCollapse: "collapse",
                      fontSize: "12px",
                    }}
                  >
                    <thead>
                      <tr>
                        <th width={`${100 / 3}%`}></th>
                        <th width={`${100 / 3}%`}></th>
                        <th width={`${100 / 3}%`}></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ padding: 4, border: "4px solid white" }}>
                          <p style={{ fontWeight: "bold", fontSize: "12px" }}>
                            E-mails to be distributed to your HSE
                            <br /> Department: hse@transguardgroup.com
                          </p>
                        </td>
                        <td style={{ padding: 4, border: "4px solid white" }}>
                          <p
                            style={{
                              fontWeight: "bold",
                              textAlign: "center",
                              fontSize: "12px",
                            }}
                          >
                            It is the responsibility of the sender to contact
                            <br /> HSE that they have received the e-mail. the
                          </p>
                        </td>
                        <td style={{ padding: 4, border: "4px solid white" }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-end",
                              justifyContent: "flex-end",
                            }}
                          >
                            <p
                              style={{
                                fontWeight: "bold",
                                visibility: "hidden",
                                fontSize: "12px",
                              }}
                            >
                              .
                            </p>
                            <p
                              style={{
                                fontWeight: "bold",

                                fontSize: "12px",
                              }}
                            >
                              For any queries, please contact DOC at 8001444
                            </p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
